import '.d{display:flex;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { Markdown } from '@app/components/core/markdown/Markdown'
import { SectionHeader } from '../blocks/SectionHeader'
import { ReactNode } from 'react'
import { Image } from '@app/components/core/image/Image'

interface ColumnItem {
  imageSrc?: string
  imageAlt?: string
  imageStyle?: Style
  markdown?: string
  listStyle?: 'bullet' | 'check'
  content?: ReactNode
  style?: Style
}

export interface ColumnsContentSectionProps {
  id?: string
  title?: string
  columns: (ColumnItem | null)[]
  style?: Style
}

export const ColumnsContentSection = ({
  id,
  title,
  columns,
  style,
}: ColumnsContentSectionProps) => {
  const isMobile = useMediaQuery()

  return (
    <>
      {title && <SectionHeader title={title} />}

      <styled.div className="d c"
        id={id}
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          ...style,
        }}
      >
        {columns
          .filter((column): column is ColumnItem => column !== null)
          .map(
            (
              {
                markdown,
                listStyle,
                imageSrc,
                imageAlt,
                imageStyle,
                style,
                content,
              },
              index,
            ) => (
              <Column
                key={index}
                gap={0}
                alignItems="stretch"
                style={{
                  flex: 1,
                  minWidth: 0,
                  ...style,
                }}
              >
                {markdown && (
                  <Markdown content={markdown} listStyle={listStyle} />
                )}
                {content}
                {imageSrc && (
                  <Image
                    src={imageSrc}
                    alt={imageAlt || `Column image ${index + 1}`}
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: 'var(--border-radius-image)',
                      ...imageStyle,
                    }}
                  />
                )}
              </Column>
            ),
          )}
      </styled.div>
    </>
  )
}
